export default {
  listYear: ['zero', 'one', 'two', 'three', 'four', 'five'],

  listYearByKey: {
    zero: { key: 'zero', value: '0' },
    one: { key: 'one', value: '1' },
    two: { key: 'two', value: '2' },
    three: { key: 'three', value: '3' },
    four: { key: 'four', value: '4' },
    five: { key: 'five', value: '5' },
  },

  defaultYearSelect: 'one',

  errorInput: {
    inputCharacter: 'Onlyinputnumber',
  },
};
